import { cn } from "@/shared/lib/utils";

interface SummaryCardProps {
  icon: React.ElementType;
  iconColor: string;
  title: React.ReactNode;
  children: React.ReactNode;
  action?: React.ReactNode;
  tone?: "danger" | "warning" | "success";
}

export function SummaryCard({ icon: Icon, iconColor, title, children, action, tone = "warning" }: SummaryCardProps) {
  const toneClasses = {
    danger: "ring-[#1A1D23]",
    warning: "ring-[#1A1D23]",
    success: "ring-[#1A1D23]",
  };

  return (
    <div className={cn(
      "flex flex-col rounded-xl overflow-hidden",
      "bg-[#1A1D23]",
      toneClasses[tone],
      "backdrop-blur-xl border border-[#1A1D23] shadow-xl ring-1",
    )}>
      {/* Header — title on the left, action on the right */}
      <div className="flex items-center justify-between gap-2 px-4 py-3 border-b border-border/20">
        <div className="flex items-center gap-2 min-w-0">
          <div className={cn("flex items-center justify-center w-7 h-7 rounded-lg flex-shrink-0", iconColor)}>
            <Icon className="h-3.5 w-3.5" />
          </div>
          <div className="min-w-0 text-sm font-semibold text-foreground">{title}</div>
        </div>
        {action && <div className="flex-shrink-0">{action}</div>}
      </div>
      {/* Body */}
      <div className="flex-1 flex flex-col px-4 py-3">
        {children}
      </div>
    </div>
  );
}
